import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe('pk_live_51TJCaEILOpB6RcrOPQSGfLoMfIyafPkLtFWXqA8p179djSsdP5s4fqZgFMJ8CjbNxFEgT49V1yvHOppcOwj40T0y004ayWAIfI');

export default stripePromise;
